import { TRenderItemWithKey } from '../components/Path';
import { TPath, TOnMove, IFolder, EFolderType } from '../../modules/items/types/folders.types';
import { AccessType } from '@modules/access';
import { useContext } from 'react';
import { SignInContext } from '@modules/users';

type TMoveOption = {
  onMove: TOnMove;
  folder: IFolder;
};

// Typically used for "just folder items"
export const useFolderPathAsBreadcrumbs = (path: TPath, moveOption?: TMoveOption): TRenderItemWithKey[] => {
  const { organization } = useContext(SignInContext);
  const isQm = organization.folders.qm === path[0]?._id;
  return path.map((pathItem, idx) => {
    const isCountriesRoot = idx === 0 && organization.folders.countries === pathItem._id;
    // If an explicit href is present, use it. See `SingleSubmissionContent` for an example.
    const href =
      pathItem.href ??
      (!isQm && !isCountriesRoot && idx === 0 ? `/product/${pathItem._id}` : `/folder/${pathItem._id}`);

    let onMoveItem: TOnMove | undefined = undefined;
    if (moveOption) {
      const { onMove, folder } = moveOption;
      const isCountryRootLevelTarget =
        folder.folderType === EFolderType.COUNTRY &&
        ((folder.resolvedPath.length === 1 && idx === 0) || (folder.resolvedPath.length >= 2 && idx <= 1));
      if (
        folder.accessRight >= AccessType.EDIT &&
        ((isQm && folder.folderType !== EFolderType.BLOCK) || idx >= 1) && // can move into QM root (but not if it's a block folder) + cannot move into a product root
        idx < path.length - 1 &&
        pathItem.accessRight >= AccessType.EDIT &&
        !isCountryRootLevelTarget
      )
        onMoveItem = onMove;
    }

    return {
      key: idx,
      id: pathItem._id,
      text: pathItem.name,
      icon: pathItem.icon,
      disabled: pathItem.disabled,
      href,
      target: pathItem.target ?? '_self',
      onMove: onMoveItem,
    };
  });
};
